import { Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { ChangeSet } from 'prosemirror-changeset';
import { recreateTransform } from '@fellow/prosemirror-recreate-transform';
import { EditorState, PluginKey } from 'prosemirror-state';
import { DOMSerializer } from 'prosemirror-model';
export function changesetStateFrom(previousDoc, currentState, stepsSinceLastChange) {
  let stepMaps;
  let decos = DecorationSet.empty;
  try {
    if (stepsSinceLastChange.length !== 0) {
      stepMaps = stepsSinceLastChange.map(step => step.getMap());
    } else {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      stepMaps = recreateTransform(previousDoc, currentState.doc, {
        complexSteps: true,
        // Whether step types other than ReplaceStep are allowed.
        wordDiffs: true,
        // Whether diffs in text nodes should cover entire words.
        simplifyDiff: true // Whether steps should be merged, where possible
      }).mapping.maps;
    }
    let changes = ChangeSet.create(previousDoc).addSteps(currentState.doc, stepMaps, []).changes;
    for (let change of changes) {
      if (change.inserted.length > 0) {
        let changeDecos = [];

        //gather all nodes between the change fromB and toB
        currentState.doc.nodesBetween(change.fromB, change.toB, function (node, pos) {
          if (node.isBlock) {
            highlightNode(node, pos, change.fromB, change.toB, changeDecos);
          }
        }, change.fromB);

        //applies class to inline nodes so that inner text is also highlighted
        changeDecos.push(Decoration.inline(change.fromB, change.toB, {
          class: 'embercom-prosemirror-composer-diffing-insertion'
        }));
        decos = decos.add(currentState.doc, [...changeDecos]);
      }
      if (change.deleted.length > 0) {
        let dom = document.createElement('span');
        dom.setAttribute('class', 'embercom-prosemirror-composer-diffing-deletion');
        let deletionDomElements = DOMSerializer.fromSchema(currentState.schema).serializeFragment(previousDoc.slice(change.fromA, change.toA < previousDoc.content.size ? change.toA : previousDoc.content.size).content);
        [...deletionDomElements.children].forEach(child => child.classList.add('embercom-prosemirror-composer-diffing-deletion'));
        dom.appendChild(deletionDomElements);
        let deco = Decoration.widget(change.fromB, dom, {
          marks: []
        });
        decos = decos.add(currentState.doc, [deco]);
      }
    }
  } catch (e) {
    // catch the error and log it to the console instead of letting it break the editor
    // we use a third party libary to recreate the transform and it can throw errors
    console.error('Error in changesetStateFrom', e);
  }
  let historyState = EditorState.create({
    doc: currentState.doc,
    plugins: [new Plugin({
      key: new PluginKey('highlightDiffs'),
      props: {
        decorations() {
          return decos;
        }
      }
    })]
  });
  return historyState;
}
function highlightNode(node, pos, changeFromB, changeToB, changeDecos) {
  //finds the start and end of that node
  let fromB = pos - changeFromB;
  let toB = fromB + node.nodeSize;
  //if they are within the changes range apply the node decoration
  if (fromB >= changeFromB && toB <= changeToB) {
    changeDecos.push(Decoration.node(fromB, toB, {
      class: 'embercom-prosemirror-composer-diffing-insertion'
    }));
  }
}